import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideOwnerForm from '../containers/CareGuideOwnerFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideOwnerAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideOwnerAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_owner_route_add')} />
          <CareGuideOwnerForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideOwnerAddScreen;

Logger.log('silly', `CareGuideOwnerAddScreen loaded.`);
